
import React from "react";
import { useSearchParams } from "@rivtn/noseur";
import { i18nManager } from "../i18n";
import PageHead from "./common/PageHead";
import Pagination from "./common/Pagination";
import GalleryItem from "./common/GalleryItem";
import FilterChips from "./common/FilterChips";
import { Utils } from "../../../../utils";
import styles from "../assets/style.module.css";
import { ApiResponseData, BaseService, IGallery, ITeamWebsite, OmneHostService, SanitizedResponse } from "../../../../services";

export interface GalleryProps {
    website: ITeamWebsite;
}

function Gallery({ website }: GalleryProps) {

    const labels = i18nManager.Labels.gallery;
    const omnehostService = OmneHostService.getInstance();
    const [tag, setTag] = React.useState("");
    const [gallery, setGallery] = React.useState<ApiResponseData<IGallery>>();
    const { page, setPage } = useSearchParams({ defaultInit: window.location.search, params: { page: 1 } });
    const tags = Array.from(new Set((gallery?.content ?? []).flatMap((g) => g.extra_data?.tags ?? [])));

    React.useEffect(fetchInformation, [omnehostService, page]);

    return (<>
        <PageHead kicker={labels.kicker} title={labels.title} subtitle={labels.desc} />
        <section className={styles["section-page"]}>
            <div className={styles["container"]}>
                {tags.length > 0 && (<FilterChips value={tag} onChange={setTag} options={[["", labels.all], ...tags.map((t) => [t, t] as [string, string])]} />)}
                {(!!gallery?.content)
                    ? (gallery.content.length > 0
                        ? (<div className={styles["gallery-grid"]}>
                            {gallery.content.filter((g) => !tag || g.extra_data?.tags?.includes(tag)).map((g) => (<GalleryItem key={g.external_id} gallery={g} />))}
                        </div>)
                        : Utils.emptyState())
                    : Utils.loadingState()}
                <Pagination page={parseInt(`${page}`)} rowsPerPage={gallery?.size} totalRecords={gallery?.total_elements} onPageChange={setPage} />
            </div>
        </section>
    </>);

    function fetchInformation() {
        setGallery({});
        omnehostService.queryTeamGallery(website.team.public_id, {
            page,
            sort: "updated_at,DESC",
        }).then(({ apiResponse }: SanitizedResponse<IGallery>) => {
            setGallery(apiResponse.data!);
        }).catch(BaseService.reportError);
    }
}

export default Gallery;
